module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAFVBMVEUAAABJSVJCQk5DQk1DQU5DQk1CQU1CVlPLAAAABnRSTlMAHKa25u20+nPGAAAAiUlEQVQoz2NgIAwYVdLAIEURKiCaBgWpAhABNUOoSjMFCMMNKsEg5gCh02CGsSWQIiDkBrHISQAiwBgGszoQIsCULADRIpwEEWBJhJrBmAIRgBgHItNoJQD0LUQA5Ns0SHiABcDhkYYeYmnoYZqG6nESBCC+BZmXAqEh4QEE4PBgQA8xBvQwJQQAoi00mTXAU/gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourseImages/zh@2x.png
// module id = a+tI
// module chunks = 96